import { Inject, Injectable } from '@angular/core';
import {
  OPEN_EXTERNAL_LINK_IN_OWN_TAB,
  REDIRECT_URI,
} from '@rd/core/tokens/rd-lib.token';
import { StartsWithHttps } from 'global-types';

@Injectable({
  providedIn: 'root',
})
export class TermsLinkHelper {
  constructor(
    @Inject(OPEN_EXTERNAL_LINK_IN_OWN_TAB)
    protected openExternalLinkInOwnTab: boolean,
    @Inject(REDIRECT_URI)
    protected redirectUri: StartsWithHttps,
  ) {}

  createTermsLink(params: {
    termsLinkUrl: string | URL | null;
    termsLinkText: string;
    isExternal?: boolean;
  }): string {
    const { termsLinkText, termsLinkUrl, isExternal } = params;

    let external: boolean;

    if (isExternal !== undefined) {
      external = isExternal;
    } else {
      external = !termsLinkUrl?.toString().startsWith(this.redirectUri);
    }

    if (external && !this.openExternalLinkInOwnTab) {
      return `<a class="terms-link focus-link" href="${termsLinkUrl}" target="_blank" rel="noopener noreferrer"><span class="terms-link-text">${termsLinkText}</span></a>`;
    }

    if (external && this.openExternalLinkInOwnTab) {
      return `<a class="terms-link focus-link" href="${termsLinkUrl}" target="_self" rel="noopener noreferrer"><span class="terms-link-text">${termsLinkText}</span></a>`;
    }

    return `<a class="terms-link focus-link" href="${termsLinkUrl}" target="_self"><span class="terms-link-text">${termsLinkText}</span></a>`;
  }
}
